module.exports = __webpack_public_path__ + "static/img/e1_libg1.4f930c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/e1_libg1.png
// module id = QOw0
// module chunks = 0